define.alias("shared/components/shared/upgrade/all-features-modal", "calendar/components/shared/upgrade/all-features-modal");